import React from "react";
import "../Services.css";
import { FaBullseye, FaEye, FaWrench, FaRocket, FaChartLine, FaShieldAlt, FaHeadset, FaCloudUploadAlt } from "react-icons/fa";

const servicesData = [
  {
    icon: <FaBullseye size={45} />,
    title: "Strategy & Planning",
    description: "We assess your business requirements and design a comprehensive ERP strategy that supports your operational and financial objectives. Our consulting approach ensures a smooth digital transformation journey.",
    gradient: "gradient-1",
    delay: "0s"
  },
  {
    icon: <FaEye size={45} />,
    title: "Process Optimization",
    description: "We optimize business processes across finance, procurement, inventory, sales, manufacturing, and human resources to improve efficiency and visibility throughout your organization.",
    gradient: "gradient-2",
    delay: "0.1s"
  },
  {
    icon: <FaWrench size={45} />,
    title: "Systems Implementation",
    description: "Our implementation specialists deliver successful ERP and enterprise software deployments, including customization, integration, migration, training, and ongoing support to ensure long-term business success.",
    gradient: "gradient-3",
    delay: "0.2s"
  },
  {
    icon: <FaRocket size={45} />,
    title: "Digital Transformation",
    description: "Accelerate your business growth with cutting-edge digital solutions and modern technology integration.",
    gradient: "gradient-4",
    delay: "0.3s"
  },
  {
    icon: <FaChartLine size={45} />,
    title: "Analytics & Insights",
    description: "Make data-driven decisions with advanced analytics, real-time dashboards, and intelligent business insights.",
    gradient: "gradient-1",
    delay: "0s"
  },
  {
    icon: <FaShieldAlt size={45} />,
    title: "Security & Compliance",
    description: "Ensure data protection and regulatory compliance with enterprise-grade security measures.",
    gradient: "gradient-2",
    delay: "0.1s"
  }
];

const Services = () => {
  return (
    <>
      <div className="space"></div>
      <div id="services">
        <div className="services-container">
          <div className="section-header">
            <span className="section-badge">Our Services</span>
            <h2 className="section-title">
              Comprehensive <span className="highlight">Enterprise Solutions</span>
            </h2>
            <p className="section-subtitle">
              We provide end-to-end solutions to transform your business operations
            </p>
          </div>

          <div className="services-grid">
            {servicesData.map((service, index) => (
              <div
                key={index}
                className="service-card-wrapper"
                style={{ animationDelay: service.delay }}
              >
                <div className={`service-card ${service.gradient}`}>
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <div className="service-number">0{index + 1}</div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  <div className="service-hover-effect"></div>
                 
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;